import { UserRole, UserRoleAdmin, UserRoleStorage, UserRoleSustainability, UserRoleTerminal } from "./WebApiClient";

export const UserRoles: { key: UserRole, displayName: string }[] = [
    { key: UserRole.None, displayName: "None" },
    { key: UserRole.ProjectManager, displayName: "Project Manager" },
    { key: UserRole.GroupManager, displayName: "Group Manager" },
    { key: UserRole.Customer, displayName: "Customer Representative" }
];

export const UserRolesAdmin: { key: UserRoleAdmin, displayName: string }[] = [
    { key: UserRoleAdmin.None, displayName: "None" },
    { key: UserRoleAdmin.EditGlobal, displayName: "Edit Global" }
];

export const UserRolesStorage: { key: UserRoleStorage, displayName: string }[] = [
    { key: UserRoleStorage.None, displayName: "None" },
    { key: UserRoleStorage.ReadCustomer, displayName: "Read Customer" },
    { key: UserRoleStorage.EditCustomer, displayName: "Edit Customer" },
    { key: UserRoleStorage.EditGlobal, displayName: "Edit Global" }
];

export const UserRolesSustainability: { key: UserRoleSustainability, displayName: string }[] = [
    { key: UserRoleSustainability.None, displayName: "None" },
    { key: UserRoleSustainability.ReadCustomer, displayName: "Read Customer" },
    { key: UserRoleSustainability.ReadGlobal, displayName: "Read Global" },
    { key: UserRoleSustainability.EditGlobal, displayName: "Edit Global" },
];

export const UserRolesTerminal: { key: UserRoleTerminal, displayName: string }[] = [
    { key: UserRoleTerminal.None, displayName: "None" },
    { key: UserRoleTerminal.Supervisor, displayName: "Supervisor" },
    { key: UserRoleTerminal.Manager, displayName: "Manager" },
    { key: UserRoleTerminal.Operator, displayName: "Operator" },
    { key: UserRoleTerminal.Docker, displayName: "Docker" },
    { key: UserRoleTerminal.TerminalCreateOperation, displayName: "TerminalCreateOperation" }, //PLACEHOLDER NAME
    { key: UserRoleTerminal.TerminalAcceptOperation, displayName: "TerminalAcceptOperation" }, //PLACEHOLDER NAME
];

export const TabletWidth: number = 1250;
